import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Col, Row, Skeleton, Select } from 'antd'
import { useLocation, useNavigate } from 'react-router'
import { RootState } from '../../../../store/store'
import { useSelector } from 'react-redux'
import { openNotificationWithIcon } from '../../../../utils/helper'
import { getCurriculumAssignment } from '../../../../api/curriculum/curriculum'
import { getStudentClasses } from '../../../../api/class/class'
import Curriculumcard from './curriculumcard/curriculumcard'

const { Option } = Select

const tutorTypes = ['aiTutor', 'teacher', 'parent']

const Studentlessons = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const [currentCurriculumId, setCurrentCurriculumId] = useState('')
	const [selectedClassId, setSelectedClassId] = useState('')
	const [currentAssignedBy, setCurrentAssignedBy] = useState(tutorTypes[0])
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])
	const [studentClasses, setStudentClasses] = useState([])
	const [loadingClasses, setLoadingClasses] = useState(false)

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'My Lessons'
			}
		})

		// eslint-disable-next-line
	}, [])



	const updateCurrentCurriculum = (curriculumcard: string) => {
		setCurrentCurriculumId(curriculumcard)
	}

	const requestParams = useMemo(() => {
		return {
			assigneeId: user?._id,
			classId: selectedClassId === '' ? undefined : selectedClassId,
			assignerId: currentAssignedBy === tutorTypes[0] ? user?.aiTutorDetails?._id : currentAssignedBy === tutorTypes[1] ? undefined : user?.parentId?._id
		}

		// eslint-disable-next-line
	}, [user, currentAssignedBy, selectedClassId])

	const fetchClasses = async () => {
		try {
			setLoadingClasses(true)
			const res = await getStudentClasses({}, user?._id)
			const { data } = res?.data
			setStudentClasses(data)
			setLoadingClasses(false)
		} catch (error: any) {
			setLoadingClasses(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get Classes', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get Classes', 'Something went wrong')
			}
		}
	}

	const fetchCurriculumAssignment = useCallback(
		async () => {
			let runFetch = false
			if (currentAssignedBy === tutorTypes[1]) {
				if (selectedClassId !== '') {
					runFetch = true
				}
			} else {
				runFetch = true
			}

			if (runFetch) {
				try {
					setLoading(true)
					const res = await getCurriculumAssignment(requestParams)
					const { data } = res?.data
					setData(data)
					setLoading(false)
				} catch (error: any) {
					setLoading(false)
					if (error?.response) {
						openNotificationWithIcon('error', 'Get Curriculums', `${error?.response?.data?.message || 'Something went wrong'}`)
					} else {
						openNotificationWithIcon('error', 'Get Curriculums', 'Something went wrong')
					}
				}
			}
		},

		// eslint-disable-next-line
		[requestParams],
	)


	useEffect(() => {
		fetchCurriculumAssignment()
	}, [fetchCurriculumAssignment])


	return (
		<div className='h-screen pr-10 mt-4'>
			<Row gutter={32}>
				<Col lg={4} md={4} xs={24}>
					<div className='ml-[0.2rem]'>
						<div className='bg-appcolorwhite rounded-[30px] p-[0.6rem] custom-box-shadow-five'>
							<div className={`flex items-center p-[1.25rem] cursor-pointer mb-4 ${currentAssignedBy === tutorTypes[0] ? 'bg-appcolorpink rounded-[16px]' : ''}`}
								onClick={() => {
									setCurrentAssignedBy(tutorTypes[0])
									setSelectedClassId('')
								}}
							>
								{
									currentAssignedBy === tutorTypes[0]
										?
										<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
										: null
								}
								<span>{user?.aiTutorDetails?.name}</span>
							</div>

							<div className={`flex items-center p-[1.25rem] cursor-pointer mb-4  ${currentAssignedBy === tutorTypes[1] ? 'bg-appcolorpink rounded-[16px]' : ''}`}
								onClick={() => {
									setCurrentAssignedBy(tutorTypes[1])
									fetchClasses()
								}}
							>
								{
									currentAssignedBy === tutorTypes[1]
										?
										<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
										: null
								}
								<span>Teacher</span>
							</div>

							<div className={`flex items-center p-[1.25rem] cursor-pointer ${currentAssignedBy === tutorTypes[2] ? 'bg-appcolorpink rounded-[16px]' : ''}`}
								onClick={() => {
									if (user?.parentId === undefined) {
										openNotificationWithIcon('info', 'Get Lessons', `You don't have any parent connected yet.`)
									} else {
										setCurrentAssignedBy(tutorTypes[2])
										setSelectedClassId('')
									}
								}}
							>
								{
									currentAssignedBy === tutorTypes[2]
										?
										<span className='bg-appcolorpurplefive h-[0.3rem] w-[0.3rem] rounded-full mr-[0.6rem]'></span>
										: null
								}
								<span>Parent</span>
							</div>
						</div>
					</div>
				</Col>
				<Col lg={20} md={20} xs={24}>
					<div>
						{
							currentAssignedBy === tutorTypes[1] ?
								<>
									<div className='mb-4'>
										<p className='text-2xl font-semibold text-appcolorblackfainteleven'>Select Class</p>

										<div id="select-class-area" className='w-[31%] mt-2'>
											<Select
												loading={loadingClasses}
												placeholder="Select class"
												className='w-full capitalize'
												//@ts-ignore
												getPopupContainer={() => document.getElementById('select-class-area')}
												onSelect={(value) => {
													setSelectedClassId(value)
												}}
											>
												{
													studentClasses.map((item: any) => (
														<Option key={item._id} value={item?._id} className="capitalize">
															{item.name}
														</Option>
													))
												}
											</Select>
										</div>
									</div>
								</>
								:
								null
						}

						{
							loading ?
								<>
									<Row gutter={32}>
										{
											[1, 2, 3, 4, 5].map((item) => (
												<Col xs={24} md={24} lg={8}
													key={`lesson-student-${item}`}
												>
													<Skeleton.Button
														active={true}
														size={'large'}
														shape={'square'}
														block={true}
														style={{
															height: '10rem',
															marginBottom: '1.8rem',
															borderRadius: '1rem',
															marginRight: '1rem'
														}}
													/>
												</Col>
											))
										}
									</Row>
								</>
								:
								<>
									{
										data.length === 0 ?
											<>
												<div className='flex flex-col items-center justify-center mt-10'>
													<p className='text-2xl font-semibold text-appcolorblackfainteleven'>All Good Here!</p>
													<p className='text-appcolorblackfainteleven tex-base'>
														{
															currentAssignedBy === tutorTypes[1] ?
																<>
																	{selectedClassId !== '' ?
																		<>
																			You don’t have any assignments from your {currentAssignedBy === tutorTypes[0] ? 'AI tutor' : currentAssignedBy} Check back another time.
																		</>
																		:
																		<>
																			You are yet to select a class.
																		</>
																	}
																</>
																:
																<>
																	You don’t have any assignments from your {currentAssignedBy === tutorTypes[0] ? 'AI tutor' : currentAssignedBy} Check back another time.
																</>
														}
													</p>
												</div>
											</>
											:
											<>
												<div>
													<Row gutter={16}>
														<Col lg={24} md={24} xs={24}>
															<div className=''>
																<Row gutter={32}>
																	{
																		data.map((item: any) => (
																			<Col xs={24} md={24} lg={8} key={item?._id}>
																				<Curriculumcard
																					item={item}
																					key={item?._id}
																					currentCurriculumId={currentCurriculumId}
																					updateCurrentCurriculum={updateCurrentCurriculum}
																				/>
																			</Col>

																		))
																	}
																</Row>
															</div>
														</Col>

														{/* <Col lg={15} md={24} xs={24}>
															<div>
																<Lessongroup />
															</div>
														</Col> */}
													</Row>
												</div>

											</>
									}
								</>
						}
					</div>
				</Col >
			</Row >
		</div >
	)
}

export default Studentlessons